import React, {Component} from 'react';
import renderHTML from 'react-render-html';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  Title,
  Description,
  Button
} from 'components/landing/components';

import './GetInTouch.css';


let dumbGetInTouch = dumbBem('l-offer-get-in-touch');
let GetInTouchWrp = tx(dumbGetInTouch)('div');


export class GetInTouch extends Component {
  render() {
    return (
      <GetInTouchWrp>
        <Title>{renderHTML(this.props.title)}</Title>
        <Description>{this.props.content}</Description>
        <Button onClick={this.props.onApply} modifier='reversed-colors'>APPLY</Button>
      </GetInTouchWrp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/pages/offer/getInTouch/GetInTouch.js